import { useContext } from "react";
import { UserContext } from "../context/UserContext";

export const FEATURE_KEYS = {
    VENDOR_DISCOVERY: "vendor-discovery",
    REQUISITIONS: "requisitions",
    SECURE_FILE_SHARE: "secure-file-share",
    // Gates the calculate surface only (calculated-column UI + team-column authoring). The
    // base mapped/derived value display runs for every team, unflagged.
    CALCULATED_COLUMNS: "calculated-columns",
    RFQ_WEBHOOKS: "rfq-webhooks",
    API_KEYS: "api-keys",
    PO_MANAGEMENT: "po-management",
    // Gates importing a PO placed outside Purchaser. Sending a PO is unaffected.
    PO_IMPORT: "po-import",
    // The per-vendor page inside an RFQ. Off, the vendor links go back to the inbox/tabular pages.
    RFQ_VENDOR_PAGE: "rfq-vendor-page",
    // Gates the PO Items tab. Off, the tab is hidden but ?tab=poItems still opens the view, so the
    // team can reach it while it's being built out.
    PO_LINE_ITEMS: "po-line-items",
} as const;

export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS];

export function useFeatureAccess() {
    const { user } = useContext(UserContext);
    const enabledFeatures = user?.lastTeam?.enabledFeatures ?? [];

    const isFeatureEnabled = (featureKey: string) => enabledFeatures.includes(featureKey);

    return { isFeatureEnabled, enabledFeatures };
}
